import copy from "copy-to-clipboard";
import sweetalert from "sweetalert";
class UtilGeneral {
    //private static WebURL: string = "https://unomobile.it";
    static TranslitText(text) {
        const ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        const en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = text.length; i < l; i++) {
            const s = text.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    static CopyLink(link) {
        copy((process.env.VUE_APP_PUBLIC_URL || window.location.origin) + link);
        sweetalert({
            icon: "success",
            text: "Link copied",
        });
    }
    /**
     * Rounds a number to a specific number of decimal places.
     *
     * This function safely handles floating-point rounding errors by
     * applying `Number.EPSILON` before rounding. It’s useful for
     * formatting prices, percentages, and other fixed-precision values.
     *
     * ⚠️ Note:
     * - Works best for moderate-sized numbers (e.g. 0.001 to 1e9).
     * - For high-precision financial or scientific math, use a decimal library.
     *
     * @param {number} value - The number to round.
     * @param {number} [decimals=2] - Number of decimal places to keep.
     * @returns {number} The rounded number.
     *
     * @example
     * roundTo(1.005, 2);        // → 1.01
     * roundTo(20.99 - 10.99, 2); // → 10
     */
    static roundTo(value, decimals = 2) {
        return Math.round((value + Number.EPSILON) * 10 ** decimals) / 10 ** decimals;
    }
    static Slugify(input) {
        if (!input)
            return "";
        return input
            .normalize("NFD")
            .replace(/[̀-ͯ]/g, "")
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }
}
export default UtilGeneral;
